import { HotToastService } from "@ngneat/hot-toast";

import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewContainerRef,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

import { LocalStorageService } from "src/app/utils/localstorage.service";

import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

import * as _ from "underscore";

import { Conversation } from "../conversations/panels/conversation.model";
import { AccountantService } from "../main/accountant/accountant.service";
import { ConversationsService } from "../conversations/conversations.service";
import { DashboardService } from "../dashboard.service";
import { TrackedItemsDashboardService } from "../main/accountant/tracked-items-dashboard.service";

import { DeleteConfirmationModalComponent } from "../main/accountant/modals/delete-confirmation-modal.component";
import { DashboardModule } from "../dashboard.module";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { JobTemplatesComponent } from "../main/accountant/jobs-and-tasks/job-templates/job-templates.component";
import { FilesManagerService } from "../files-manager/files-manager.service";
import { NewTrackedItemModalComponent } from "../conversations/modals/new-tracked-item-modal.component";

declare var jQuery: any;

/**
 * Dashboard main page component. It's empty for now
 */
@Component({
    selector: "templates",
    templateUrl: "./templates.component.html",
    imports: [DashboardModule, CommonModule, FormsModule, ReactiveFormsModule],
    styleUrls: [
        "../main/accountant/tracked-items-dashboard.component.css",
        "../files-manager/files-manager.component.scss",
        "./templates.component.scss",
    ]
})
export class TemplatesComponent implements OnInit {
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  defaultEmail = "";
  user: any;
  data: any;
  company: any;
  companies = [];
  tracked_items = {};
  active_template: any;
  show_templates = false;
  templates = [];

  current_conversation: Conversation;
  clients = [];

  jobsTab = true;
  clientTaskTab = false;
  defaultFoldersTab = false;
  activeTab = "clientTaskTab";
  defaultWorkspaceTab = false;
  sharedStaff: string = "client";
  dfTabTitle: string = "Client Shared Default Folders";
  defaultsToShow: any = [];
  is_loading: boolean;
  currentFolder: any = [];
  btnFolderBackVisible: boolean = false;
  uuidToDelete: any;
  clientSharedCount: any = 0;
  clientSharedCountDisplay: any = "0 folders";
  internalCount: any = 0;
  internalCountDisplay: any = "0 folders";
  prefillRename: string;
  createFolderVisible: boolean = false;

  renameFolderVisible: boolean = false;

  constructor(
    private localStorage: LocalStorageService,
    private accountantService: AccountantService,
    private modalService: BsModalService,
    private conversationsService: ConversationsService,
    public toastr: HotToastService,
    private dashboardService: DashboardService,
    private filesManagerService: FilesManagerService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.accountantService.get_clients().then((res: any) => {
      this.clients = res;
    });

    this.dashboardService.show_loading.next(true);
    this.conversationsService.get_tracked_items_template().then(
      (res: any) => {
        console.log(res);
        this.templates = res.tracked_item_templates;
        if (this.templates.length > 0) {
          this.selectTemplate(this.templates[0]);
        }
        this.dashboardService.show_loading.next(false);
      },
      (err) => {
        this.dashboardService.show_loading.next(false);
        console.log(err);
      },
    );

    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");
    this.company = this.localStorage.get("company");

    this.conversationsService.updateTrackedItem$.subscribe((res) => {
      console.log("updateTrackedItem$", this.active_template);
      this.selectTemplate(this.active_template);
    });
  }

  updateTrackedItemsTemplate() {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .update_tracked_items_template(
        this.active_template["uuid"],
        this.active_template,
      )
      .subscribe(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.success(res.message);
        },
        (err) => {
          console.log(err);
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        },
      );
  }

  deleteTrackedItemsTemplate() {
    this.dashboardService.show_loading.next(true);
    this.conversationsService
      .delete_tracked_items_template(this.active_template["uuid"])
      .subscribe(
        (res: any) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.success(res.message);

          this.templates = this.templates.filter((t) => {
            return t.id != this.active_template["id"];
          });

          this.active_template = {};

          if (this.templates.length > 0) {
            this.active_template = this.templates[0];
          }
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        },
      );
  }

  async selectTemplate(template) {
    let res = await this.conversationsService.get_tracked_items_template_detail(
      template.uuid,
    );
    console.log("response from select template", res);
    this.active_template = res;
    this.cdr.detectChanges();
  }

  switchTabs(tab: any) {
    this.clientTaskTab = false;
    this.jobsTab = false;
    this.defaultFoldersTab = false;
    this.defaultWorkspaceTab = false;
    this.activeTab = tab;

    tab === "clientTaskTab" ? (this.clientTaskTab = true) : "";
    tab === "jobsTab" ? (this.jobsTab = true) : "";
  }

  openEditModal() {
    this.bsModalRef = this.modalService.show(NewTrackedItemModalComponent, {
      class: "modal-lg",
      initialState: {
        template_edited_uuid: this.active_template["uuid"],
        editMode: true,
        editTemplateMode: true,
        tracked_items: this.active_template["tracked_items"],
      },
    });
  }
}
